package com.milta.feature.admin.presentation

import com.milta.feature.admin.domain.entity.AdminAccounts

/** State for the Admin "Utilisateurs" screen (read-only, web-only — see AdminUsersViewModel doc). */
data class AdminUsersState(
    val isLoading: Boolean = true,
    val data: AdminAccounts? = null,
    /** "server_error" | "offline". Checked before treating an empty list as genuinely "no accounts". */
    val error: String? = null,
    val searchQuery: String = "",
    /** Organisations whose team list is expanded — collapsed by default (empty set at load). */
    val expandedOrganisationIds: Set<String> = emptySet(),
)
